module.exports = __webpack_public_path__ + "img/instagram.2aa88e44.svg";